import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from './handlers';

declare const window: any;

export const rulesValidatorApi = createApi({
    reducerPath: 'rulesValidatorApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.RULE_VALIDATOR_API ?? "https://npr-product-rules-validator.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['RuleValidator'],
    endpoints: (builder) => ({
        validateSelection: builder.mutation({
            async queryFn({productKey,locale,tempSelection,isV2Product,merchantProductVersion}, {dispatch}, _extraOptions,  baseQuery) 
            {
                let url=`v2/${productKey}/validate?`
                Object.entries(tempSelection).forEach(([attributeKey, attributeValue]) => {
                    url += `selectedAttributes.${encodeURIComponent(attributeKey)}=${encodeURIComponent(attributeValue as any)}&`;
                });
                
                url += `locale=${encodeURIComponent(locale)}`;

                if (isV2Product) {
                    url += `&isV2Product=true`;
                }
                if(merchantProductVersion){
                    url += `&version=${merchantProductVersion}`;
                }
                const response:any = await baseQuery({
                    url, 
                    method: 'GET',
                })
                return response;
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data
                }
                catch (error) {
                    console.log(error);
                    dispatch(onErrorHandler({ operation: "validateSelection", err: JSON.stringify(error), errMsg: 'Error: while validating selection', api: 'v2/productKey/validate'}));
                }
            }
        }),
    }),
})

export const { 
    useValidateSelectionMutation, 
} = rulesValidatorApi;

